module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kb-article-editor"
  }, [_c('div', {
    staticClass: "panel h1-panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/kb"
    }
  }, [_vm._v("Knowledge Base")])], 1)]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('section', {
    staticClass: "panel editor-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(!_vm.isLoading) ? _c('div', [(_vm.isCreating) ? _c('h2', [_vm._v("Create Article")]) : _vm._e(), _vm._v(" "), (_vm.isUpdating) ? _c('h2', [_vm._v("Edit Article")]) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.isSubmitting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Title")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "E.g. How many polygons should I use?"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Category")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.categoryOptionsAsLabels
    },
    model: {
      value: (_vm.categories),
      callback: function($$v) {
        _vm.categories = $$v
      },
      expression: "categories"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Term Type")]), _vm._v(" "), _c('multiselect', {
    staticClass: "term-type-multiselect",
    attrs: {
      "options": _vm.termTypeOptions
    },
    model: {
      value: (_vm.termTypes),
      callback: function($$v) {
        _vm.termTypes = $$v
      },
      expression: "termTypes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Path")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "options": _vm.pathOptionsAsNames
    },
    model: {
      value: (_vm.paths),
      callback: function($$v) {
        _vm.paths = $$v
      },
      expression: "paths"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Software")]), _vm._v(" "), _c('software-select', {
    attrs: {
      "options": _vm.softwareOptions
    },
    model: {
      value: (_vm.software),
      callback: function($$v) {
        _vm.software = $$v
      },
      expression: "software"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Tags")]), _vm._v(" "), _c('tag-select', {
    attrs: {
      "canCreate": true,
      "search": _vm.searchTags
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Cover Image")]), _vm._v(" "), _c('div', {
    staticClass: "cover-img-group"
  }, [(_vm.coverImageUrl) ? _c('img', {
    staticClass: "cover-img",
    attrs: {
      "src": _vm.coverImageUrl
    }
  }) : (_vm.defaultCoverImageUrl) ? _c('img', {
    staticClass: "cover-img",
    attrs: {
      "src": _vm.defaultCoverImageUrl
    }
  }) : _c('img', {
    staticClass: "cover-img",
    attrs: {
      "src": require("../assets/img/ttto-thumbnail.jpg")
    }
  }), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "btn btn-default"
  }, [_vm._v("\n                                        Upload\n                                        "), _c('input', {
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.setCoverImage($event.target.files[0])
      }
    }
  })]), _vm._v(" "), (_vm.coverImageUrl) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.resetCoverImage()
      }
    }
  }, [_vm._v("\n                                        Reset\n                                    ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Overview")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.overview),
      expression: "overview"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "E.g. Finding the balance between performance and respresentation"
    },
    domProps: {
      "value": (_vm.overview)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.overview = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Body")]), _vm._v(" "), _c('html-editor', {
    ref: "htmlEditor",
    attrs: {
      "contentClass": "kb-article",
      "stickyToolbar": true,
      "tagMap": {
        h1: 'h3',
        h2: 'h4'
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group submit-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.submitText
    },
    on: {
      "click": function($event) {
        _vm.submitArticle()
      }
    }
  })])])])]) : _c('div', {
    staticClass: "loading-msg"
  }, [_vm._v("\n                Loading...\n            ")])])]), _vm._v(" "), (_vm.isUpdating) ? _c('section', {
    staticClass: "panel delete-panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Delete Article")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.deleteArticle()
      }
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.isDeleting
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deletionText),
      expression: "deletionText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Type \"delete me\" to enable the button below"
    },
    domProps: {
      "value": (_vm.deletionText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deletionText = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group submit-group"
  }, [_c('input', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "submit",
      "value": "Delete",
      "disabled": !_vm.canDelete
    }
  })])])])])]) : _vm._e(), _vm._v(" "), _c('kb-feedback')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('h2', [_vm._v("Article Editor")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-41eb609c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KbArticleEditor.vue
// module id = 2007
// module chunks = 2